import React, { useEffect, useRef, useState } from 'react'
import './Settingslinking.css'
import back from "../../imgs/backexam.png";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from '../../Context/Globalcontext';

const Settingslinking = (props) => {
    const inputRefs = useRef([]);
    const [newedit, setNewedit] = useState("new");
    const [input, setInput] = useState({
        mainuser: "", thevregular: "", thevregularname: "", thev1: "", thev1name: "", thev2: "", thev2name: "", thev3: "", thev3name: "",
        advchalu: "", advchaluname: "", advkapat: "", advkapatname: "", khchalu: "", khchaluname: "", ratibchalu: "", ratibchaluname: "", hptachalu: "", hptachaluname: "",
        intrchalu: "", intrchaluname: "", sanghkchalu: "", sanghkchaluname: "", retanchalu: "", retanchaluname: "", vahtuk: "", vahtukname: "",comm:"",commname:"",ada:"",adaname:"",billamt:"",billamtname:"",kapat1:"",kapat1name:""
        ,kapat2:"",kapat2name:"",kapat3:"",kapat3name:""
    });
    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [khnames, setKhnames] = useState([]);
    const [value, setValue] = useState('');
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [stock, setStock] = useState();
    const [sredit, setSredit] = useState('');
    const [wait, setWait] = useState(false);
    const [retan, setRetan] = useState('Off');
    const [medi, setMedi] = useState('Off');
    const [karj, setKarj] = useState('Off');
    const [bhishi, setBhishi] = useState('Off');
    const [sanghk, setSanghk] = useState('Off');

    function handleEnterKey(event, currentIndex) {
        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;
            nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === 'प्रकार निवडा')
            ))
        )) {
            event.preventDefault();

            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if (
                        (prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') &&
                        prevElement !== event.target
                    ) {
                        prevElement.focus();
                        break;
                    } else {
                        prevIndex--;
                    }
                } else {
                    prevIndex--;
                }
            }
        }
    }

    useEffect(() => {
        getlinksettings();
    }, [])

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;

        setInput(value => ({ ...value, [name]: valuecurrent }));
    }

    async function savesettingslink() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        let rawData = {
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            thevregular: input.thevregular,
            thev1: input.thev1,
            thev2: input.thev2,
            thev3: input.thev3,
            advchalu: input.advchalu,
            advkapat: input.advkapat,
            khchalu: input.khchalu,
            khkapat: input.khkapat,
            ratibchalu: input.ratibchalu,
            ratibkapat: input.ratibkapat,
            hptachalu: input.hptachalu,
            intrchalu: input.intrchalu,
            sanghkchalu: input.sanghkchalu,
            sanghkkapat: input.sanghkkapat,
            retanchalu: input.retanchalu,
            retankapat: input.retankapat,
            kapat1: input.kapat1,
            kapat2: input.kapat2,
            kapat3: input.kapat3,
            vahtuk: input.vahtuk,
            comm: input.comm,
            billamt: input.billamt,
            ada: input.ada,
        }
        rawData = JSON.stringify(rawData);

        let formData = new FormData()
        if (newedit === "edit") {
            formData.append('data', rawData)
        }
        else if (newedit === "new") {
            formData.append('data', rawData)
        }

        axios.post('https://excellentdairy.com/dairy/php/cust/savesettingslink.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {

            notify("लिंकिंग अपडेट झाले!");
            getlinksettings();
        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    async function getlinksettings() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => {
            props.setProgress(50);
        }, 200);
        axios.post('https://excellentdairy.com/dairy/php/cust/getlinksettings.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {

            if (response.data) {
                response.data.forEach((user, index) => {
                    localStorage.setItem("thevregular", user.thevregular);
                    localStorage.setItem("thev1", user.thev1);
                    localStorage.setItem("thev2", user.thev2);
                    localStorage.setItem("thev3", user.thev3);
                    localStorage.setItem("advchalu", user.advchalu);
                    localStorage.setItem("advkapat", user.advkapat);
                    localStorage.setItem("khchalu", user.khchalu);
                    localStorage.setItem("khkapat", user.khkapat);
                    localStorage.setItem("ratibchalu", user.ratibchalu);
                    localStorage.setItem("ratibkapat", user.ratibkapat);
                    localStorage.setItem("hptachalu", user.hptachalu);
                    localStorage.setItem("intrchalu", user.intrchalu);
                    localStorage.setItem("sanghkchalu", user.sanghkchalu);
                    localStorage.setItem("sanghkkapat", user.sanghkkapat);
                    localStorage.setItem("retanchalu", user.retanchalu);
                    localStorage.setItem("retankapat", user.retankapat);
                    localStorage.setItem("kapat1", user.kapat1);
                    localStorage.setItem("kapat2", user.kapat2);
                    localStorage.setItem("kapat3", user.kapat3);
                    localStorage.setItem("vahtuk", user.vahtuk);
                    localStorage.setItem("comm", user.comm);
                    localStorage.setItem("ada", user.ada);
                    localStorage.setItem("billamt", user.billamt);
                });

                response.data.forEach((user, index) => {
                    setInput(prevInput => ({
                        ...prevInput,
                        thevregular: user.thevregular,
                        thev1: user.thev1,
                        thev2: user.thev2,
                        thev3: user.thev3,
                        advchalu: user.advchalu,
                        advkapat: user.advkapat,
                        khchalu: user.khchalu,
                        khkapat: user.khkapat,
                        ratibchalu: user.ratibchalu,
                        ratibkapat: user.ratibkapat,
                        hptachalu: user.hptachalu,
                        intrchalu: user.intrchalu,
                        sanghkchalu: user.sanghkchalu,
                        sanghkkapat: user.sanghkkapat,
                        retanchalu: user.retanchalu,
                        retankapat: user.retankapat,
                        kapat1: user.kapat1,
                        kapat2: user.kapat2,
                        kapat3: user.kapat3,
                        vahtuk: user.vahtuk,
                        comm: user.comm,
                        ada: user.ada,
                        billamt: user.billamt,
                    }))
                });


                setTimeout(() => {
                    props.setProgress(100);
                }, 200);
            }
        }).catch(err => {
            console.log(err);
        });
    }



    useEffect(() => {
        // 1. Pull audit list once
        const auditList = JSON.parse(localStorage.getItem("auditlist") || "[]");

        // 2. Define the fields you want to mirror with a “name” suffix
        const fields = ["thevregular", "thev1", "thev2", "thev3", "advchalu", "advkapat", "khchalu", "khkapat", "ratibchalu", "ratibkapat", "hptachalu", "intrchalu", "sanghkchalu", "sanghkkapat", "retanchalu", "retankapat","kapat1","kapat2","kapat3","vahtuk", "comm", "ada","billamt" /* , add more here if needed */];

        // 3. Build an object of updates
        const updates = fields.reduce((acc, field) => {
            const val = input[field];
            const nameKey = `${field}name`;

            if (!val) {
                // If the value is empty, clear the name
                acc[nameKey] = "";
            } else {
                // Otherwise try to find the matching user once
                const user = auditList.find((u) => u.kno === val);
                acc[nameKey] = user?.name || "";
            }

            return acc;
        }, {});

        // 4. Apply all updates in one go
        setInput((prev) => ({
            ...prev,
            ...updates,
        }));
    }, [input.thevregular, input.thev1, input.thev2, input.thev3, input.advchalu, input.advkapat, input.khchalu, input.khkapat, input.ratibchalu, input.ratibkapat, input.hptachalu, input.intrchalu, input.sanghkchalu, input.sanghkkapat, input.retanchalu, input.retankapat,input.kapat1,input.kapat2,input.kapat3,input.vahtuk, input.comm, input.ada,input.billamt /*, add more dependencies as you add fields */]);


    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            // Make sure that the input is a string
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                // Create block
                var a = str.charCodeAt(i);
                // Bitwise XOR
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    return (
        <div>
            <div className="ratemain">
                <div className="firstrowrepair">
                    <img onClick={props.visibility} className='back' src={back} alt="" />
                    <span>सभासद बिलामधील खालील खाती तुम्ही ऑटिड खात्यांशी लिंक करू शकता! </span>
                    {
                        wait ?
                            <button onKeyDown={e => handleEnterKey(e, 18)} ref={ref => (inputRefs.current[18] = ref)} type='button' id='savelink' className="btn btn-primary">लोडिंग...</button>
                            :
                            <button onClick={savesettingslink} onKeyDown={e => handleEnterKey(e, 18)} ref={ref => (inputRefs.current[18] = ref)} type='button' id='savelink' className="btn btn-primary">सेट करा</button>
                    }
                </div>


                <div className="settingslinkmain">
                    <div className="firstrowrepair">
                        <span className='titleaudit'>1. ठेव कपात रेग्युलर</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="thevregular" name="thevregular" value={input.thevregular} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="thevregularname" name="thevregularname" value={input.thevregularname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>2. ठेव कपात १</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="thev1" name="thev1" value={input.thev1} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="thev1name" name="thev1name" value={input.thev1name} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>3. ठेव कपात २</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="thev2" name="thev2" value={input.thev2} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="thev2name" name="thev2name" value={input.thev2name} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>4. ठेव कपात ३</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="thev3" name="thev3" value={input.thev3} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="thev3name" name="thev3name" value={input.thev3name} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>5. एडव्हांस On</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="advchalu" name="advchalu" value={input.advchalu} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="advchaluname" name="advchaluname" value={input.advchaluname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>6. एडव्हांस कपात</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="advkapat" name="advkapat" value={input.advkapat} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="advkapatname" name="advkapatname" value={input.advkapatname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>7. खाद्य On</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="khchalu" name="khchalu" value={input.khchalu} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="khchaluname" name="khchaluname" value={input.khchaluname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>8. खाद्य कपात</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="khkapat" name="khkapat" value={input.khkapat} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="khkapatname" name="khkapatname" value={input.khkapatname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>9. रतीब On</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="ratibchalu" name="ratibchalu" value={input.ratibchalu} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="ratibchaluname" name="ratibchaluname" value={input.ratibchaluname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>10. रतीब कपात</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="ratibkapat" name="ratibkapat" value={input.ratibkapat} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="ratibkapatname" name="ratibkapatname" value={input.ratibkapatname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>11. कर्ज हप्ता</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="hptachalu" name="hptachalu" value={input.hptachalu} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="hptachaluname" name="hptachaluname" value={input.hptachaluname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>12. कर्ज व्याज</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="intrchalu" name="intrchalu" value={input.intrchalu} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="intrchaluname" name="intrchaluname" value={input.intrchaluname} onChange={handleChange} placeholder='ऑडिट खाते नाव '></input>
                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>13. संघ खरेदी On</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="sanghkchalu" name="sanghkchalu" value={input.sanghkchalu} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="sanghkchaluname" name="sanghkchaluname" value={input.sanghkchaluname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>14. संघ कपात</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="sanghkkapat" name="sanghkkapat" value={input.sanghkkapat} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="sanghkkapatname" name="sanghkkapatname" value={input.sanghkkapatname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>15. रेतन/औषध On</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="retanchalu" name="retanchalu" value={input.retanchalu} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="retanchaluname" name="retanchaluname" value={input.retanchaluname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>16. रेतन/औषध Credit</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="retankapat" name="retankapat" value={input.retankapat} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="retankapatname" name="retankapatname" value={input.retankapatname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>17. कपात 1</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="kapat1" name="kapat1" value={input.kapat1} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="kapat1name" name="kapat1name" value={input.kapat1name} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>18. कपात 2</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="kapat2" name="kapat2" value={input.kapat2} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="kapat2name" name="kapat2name" value={input.kapat2name} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>19. कपात 3</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="kapat3" name="kapat3" value={input.kapat3} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="kapat3name" name="kapat3name" value={input.kapat3name} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                        <span className='titleaudit'>20. वाहतूक</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="vahtuk" name="vahtuk" value={input.vahtuk} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="vahtukname" name="vahtukname" value={input.vahtukname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                        <span className='titleaudit'>21. कमिशन</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="comm" name="comm" value={input.comm} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="commname" name="commname" value={input.commname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                         <span className='titleaudit'>22.अदा रक्कम</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="ada" name="ada" value={input.ada} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="adaname" name="adaname" value={input.adaname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>

                    </div>

                    <div className="firstrowrepair">
                       
                        <span className='titleaudit'>23.बील रक्कम</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="text" className='form-control' autoComplete='off' id="billamt" name="billamt" value={input.billamt} onChange={handleChange} placeholder='ऑडिट खाते क्रमांक'></input>
                        <input disabled onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="text" className='form-control' autoComplete='off' id="billamtname" name="billamtname" value={input.billamtname} onChange={handleChange} placeholder='ऑडिट खाते नाव'></input>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default Settingslinking
